
import { controls } from "../controls";


const pdsearch = {
  label: "Product Search",
  pageLabel: "Product Search",
  starting: true,
  url: "pdsearch",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  filter: [  

    ...controls.displayText({tab:"filter",label: "General Ledger",width:"col-sm-2"}),
    ...controls.GL({tab: "filter"}),
    ...controls.showData({tab:"filter",data: "gl_code_display", name: "gl_code_display",width:"col-sm-2"}),


    ...controls.displayText({ tab: 'filter', label: "Product Group" }),
    ...controls.ProductGroup({ tab: 'filter' }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Product Type", width: "col-sm-2" }),
    ...controls.ProductType({
      tab: "filter",
      // sendToServer:{dataType: "producttype",sendData:[{varname:"product_group",value:"product_code_search.product_group"}]}
    }),
    ...controls.showData({ tab: "filter", data: "product_type_display", width: "col-sm-2" }),
    
    ...controls.displayText({ tab: "filter", label: "Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "name" })
  ],
  form: [],
  history: {
    perPage: 10,
    filterable: true,
    reportHeader: "Products",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "GL Code",
        accessor: "glcode",
        width: 150
      },
      {
        Header: "Code",
        accessor: "code",
      },
      {
        Header: "Name",
        accessor: "descn",
      },
      {
        Header: "guid",
        show: false,
        accessor: "guid",
      }
    ]
  }
}

export default pdsearch;